import { useState } from "react";

export default function UseLocalStorage(key) {
  	const [item, setValue] = useState(() => window.localStorage.getItem(key));

  const setItem = (key, item) => {
    setValue(item);
    window.localStorage.setItem(key, item);
  };

  return [item, setItem];
}